// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__hpR-W","image":"styles_image__wPGT9","title":"styles_title__QyHhG","message":"styles_message__4Zx6E"};